import {
  FLOW_CONDITIONAL_BOOLEAN_CONDITION_SCHEMAS,
  FLOW_CONDITIONAL_DATE_CONDITION_SCHEMAS,
  FLOW_CONDITIONAL_DATE_TIME_CONDITION_SCHEMAS,
  FLOW_CONDITIONAL_NUMBER_CONDITION_SCHEMAS,
  FLOW_CONDITIONAL_STRING_CONDITION_SCHEMAS,
  FLOW_CONDITIONAL_VALUE_CONDITION_SCHEMAS,
  FlowConditionalFieldDataType,
  type FlowConditionalOperation,
} from 'flow-schema';
import { type z } from 'zod';

export const OPERATIONS_BY_SUPPORTED_DATA_TYPE: Record<
  FlowConditionalFieldDataType,
  FlowConditionalOperation[]
> = {
  [FlowConditionalFieldDataType.String]: FLOW_CONDITIONAL_STRING_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [FlowConditionalFieldDataType.Number]: FLOW_CONDITIONAL_NUMBER_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [FlowConditionalFieldDataType.Date]: FLOW_CONDITIONAL_DATE_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [FlowConditionalFieldDataType.DateTime]: FLOW_CONDITIONAL_DATE_TIME_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [FlowConditionalFieldDataType.Boolean]: FLOW_CONDITIONAL_BOOLEAN_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [FlowConditionalFieldDataType.Value]: FLOW_CONDITIONAL_VALUE_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
};

export const VALUES_SUPPORTED_BY_DATA_TYPE: Record<
  FlowConditionalFieldDataType,
  Record<FlowConditionalOperation, string[]>
> = {
  [FlowConditionalFieldDataType.String]: FLOW_CONDITIONAL_STRING_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<FlowConditionalOperation, string[]>
  ),
  [FlowConditionalFieldDataType.Number]: FLOW_CONDITIONAL_NUMBER_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<FlowConditionalOperation, string[]>
  ),
  [FlowConditionalFieldDataType.Date]: FLOW_CONDITIONAL_DATE_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<FlowConditionalOperation, string[]>
  ),
  [FlowConditionalFieldDataType.DateTime]: FLOW_CONDITIONAL_DATE_TIME_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<FlowConditionalOperation, string[]>
  ),
  [FlowConditionalFieldDataType.Boolean]: FLOW_CONDITIONAL_BOOLEAN_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<FlowConditionalOperation, string[]>
  ),
  [FlowConditionalFieldDataType.Value]: FLOW_CONDITIONAL_VALUE_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<FlowConditionalOperation, string[]>
  ),
};

function getSupportedValues(schema: z.ZodObject<z.ZodRawShape>) {
  const supportedValues = [];
  if ('value' in schema.shape) {
    supportedValues.push('value');
  }
  if ('minValue' in schema.shape) {
    supportedValues.push('minValue');
  }
  if ('maxValue' in schema.shape) {
    supportedValues.push('maxValue');
  }
  if ('minValueInclusive' in schema.shape) {
    supportedValues.push('minValueInclusive');
  }
  if ('maxValueInclusive' in schema.shape) {
    supportedValues.push('maxValueInclusive');
  }
  if ('caseSensitivity' in schema.shape) {
    supportedValues.push('caseSensitivity');
  }
  return supportedValues;
}
